import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get, APIError } from '../services/crud'
import { ITargetPest } from './typings'
import { ISearchResponse } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.targetPest}`

export const getTargetPests = createAsyncThunk<
  ITargetPest[],
  void,
  { rejectValue: APIError }
>('targetPests/get', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) {
    const result: ISearchResponse<ITargetPest> = await response.json()
    return result.items
  }
  return thunkApi.rejectWithValue(await response.json())
})
